import { Model } from 'dva'
import { CallsListReducerState } from './types'

const initialState: CallsListReducerState = {
  list: [],
  callCategory: null,
  filters: {
    ordering: '-call_created_at',
  },
}

const Calls: Model = {
  namespace: 'calls',
  state: initialState,
  effects: {},
  reducers: {
    toggleCallCategory: (state, action) => {
      const { callCategory } = action.payload
      if (!['completed', 'ongoing', 'subtesting', 'starred'].includes(callCategory)) {
        console.error(`Invalid callCategory received: ${callCategory}`)
        return state
      }
      return {
        ...state,
        callCategory,
      }
    },
    setFilter: (state, action) => {
      const filters: { [key: string]: any } = action.payload

      // console.info("settingFilter", {filters})

      if (!filters) {
        console.error('Received invalid filter object')
        return state
      }

      return {
        ...state,
        filters: {
          ...state.filters,
          ...filters,
        },
      }
    },
    resetCalls: (state, action) => {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default Calls
